import { toast } from 'react-toastify';
import { offerEditFun, offerUploadFun } from '../../../api/addDataAPI';
import errorHandle from '../../../utils/errorHandle';
import { listOffers, supOfferCount } from '../../../api/supportAdmin';

export const addOffersSubmit = async (offersData, setLoading) => {
    try {
        const res = await offerUploadFun(offersData);
        if (res.status === 200) {
            toast.success('Offer created successfully');
            return res.status;
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const fetchOffers = async (setLoading, setOffersData, status, limit, offset) => {
    setLoading(true);
    try {
        const offers = await listOffers(limit, offset, status);
        setOffersData(offers.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
};

export const editOffersSubmit = async (id, offersData, setLoading) => {
    try {
        const res = await offerEditFun(id, offersData);
        if (res.status === 200) {
            toast.success('Offer updated successfully');
            return res.status;
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const offersCount = (setTotalCount, status, setLoading) => {
    setLoading(true);
    try {
        supOfferCount(status).then((res) => {
            setLoading(false);
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
